import { render, staticRenderFns } from "./MobileDetailsCtaAcquisition.vue?vue&type=template&id=0f1acc05&"
import script from "./MobileDetailsCtaAcquisition.vue?vue&type=script&lang=js&"
export * from "./MobileDetailsCtaAcquisition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f1acc05')) {
      api.createRecord('0f1acc05', component.options)
    } else {
      api.reload('0f1acc05', component.options)
    }
    module.hot.accept("./MobileDetailsCtaAcquisition.vue?vue&type=template&id=0f1acc05&", function () {
      api.rerender('0f1acc05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/mobiledetails/MobileDetailsCtaAcquisition.vue"
export default component.exports